import {inject, Injectable} from '@angular/core';
import {BaseContextTool} from '../common/base-context-tool';
import {SelectionTypes} from 'src/app/shared/models/diagram-interactions.interface';
import {ActivityContextBar} from './activity/activity-context-bar';
import {StickerContextBar} from './sticker/sticker-context-bar';
import {TextboxContextBar} from './textbox/textbox-context-bar';
import {ContextBarOptionGroup} from '@q9elements/ui-kit/components';

@Injectable()
export class ContextBarService extends BaseContextTool {
  private contextBar = {
    [SelectionTypes.Activity]: inject(ActivityContextBar),
    [SelectionTypes.Sticker]: inject(StickerContextBar),
    [SelectionTypes.Text]: inject(TextboxContextBar)
  };

  public getOptions(): ContextBarOptionGroup[] | null {
    const selectedCellsNames = this.getSelectionNames();
    const selectionType = selectedCellsNames.join('&');

    return this.contextBar[selectionType]?.getOptions();
  }
}
